<template src="./OrkReassurance.html"></template>
<style lang="scss" scoped src="./OrkReassurance.scss"></style>

<script>
import {
  SfIcon
} from '@storefront-ui/vue';
import icons from "@/utils/icons";

export default {
  name: 'OrkReassurance',
  components: {
    SfIcon
  },
  data() {
    return {
      icons: icons,
      reassurance: [
        {
          text: 'Secure payment',
          icon: icons.payment.path
        },
        {
          text: '48H delivery',
          icon: icons.clock.path
        },
        {
          text: 'Free return *',
          icon: icons.refound.path,
          link: '/conditions-generales-de-vente#retractation'
        }]
    }
  },
  methods: {}
};

</script>
